export const Types = {
  SAVE_LIST_TAP : 'SAVE_LIST_TAP',
  SAVE_TON_ADDRESS: "SAVE_TON_ADDRESS",
  SAVE_LIST_FARM_CONFIG: 'SAVE_LIST_FARM_CONFIG'
}
